var _style, _path, _rect, _g, _path2, _rect2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 79.2 79.4",
    style: {
      enableBackground: "new 0 0 79.2 79.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#1A1A1A;}\r\n\t.st2{fill:url(#SVGID_00000068666983648071222100000012264584849982202811_);}\r\n\t.st3{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.0897,
    y1: 39.7129,
    x2: 77.0897,
    y2: 39.7129
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC63B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9997,
    style: {
      stopColor: "#FFE73A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52,4.2C21.8-5.5-5.6,21.9,4.1,52.1C7.6,63,16.3,71.7,27.2,75.2c30.2,9.7,57.6-17.7,47.9-47.9 C71.6,16.4,62.9,7.7,52,4.2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 47.1,
    className: "st1",
    width: 31.3,
    height: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 27.8,
    cy: 28.7,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.7,
    cy: 28.7,
    r: 3
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143592756056211247360000010403073697305765521_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.0897,
    y1: 39.7129,
    x2: 77.0897,
    y2: 39.7129
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC63B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9997,
    style: {
      stopColor: "#FFE73A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143592756056211247360000010403073697305765521_)"
    },
    d: "M52,4.2C21.8-5.5-5.6,21.9,4.1,52.1 C7.6,63,16.3,71.7,27.2,75.2c30.2,9.7,57.6-17.7,47.9-47.9C71.6,16.4,62.9,7.7,52,4.2z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39.7,79.2c-4.3,0-8.7-0.7-13.1-2.1C15,73.4,5.9,64.3,2.2,52.7c-4.8-14.9-1.2-30.2,9.5-40.9 c10.7-10.7,26-14.3,40.9-9.5h0C64.2,6,73.3,15.1,77,26.7c4.8,14.9,1.2,30.2-9.5,40.9C59.9,75.2,50.1,79.2,39.7,79.2z M39.5,4.2 c-9.4,0-18.2,3.6-25,10.4C4.8,24.3,1.7,38,6,51.5C9.3,61.8,17.5,70,27.8,73.3c13.4,4.3,27.2,1.1,36.9-8.5 c9.6-9.6,12.8-23.4,8.5-36.9C69.9,17.6,61.7,9.4,51.4,6.1l0,0C47.4,4.8,43.4,4.2,39.5,4.2z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 47.1,
    className: "st1",
    width: 31.3,
    height: 4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 27.8,
    cy: 28.7,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.7,
    cy: 28.7,
    r: 3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.10268bc80e4e4da332c03aa063efd367.svg";
export { ForwardRef as ReactComponent };